var _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const Svg22 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 90.1 91",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "22")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_4",
    "data-name": "Capa 4"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M81.86,80.06c-2.53,0-5.06,0-7.59,0-.35,0-.45-.07-.45-.44q0-18.8,0-37.6a.85.85,0,0,0-.4-.79q-14-10.08-27.91-20.18c-.48-.35-.48-.35-1,0q-14,10.11-28,20.22a.75.75,0,0,0-.35.71q0,18.82,0,37.64c0,.35-.06.46-.44.46q-3.61,0-7.21,0c-.35,0-.4-.1-.4-.41q0-20.94,0-41.88a.59.59,0,0,1,.28-.55q18-13,36.08-26.1a.64.64,0,0,1,.91,0q18,13.05,36,26.08c.1.07.21.13.31.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M30.33,48.36h8.41c.3,0,.37.08.37.37q0,7,0,14c0,.28-.05.38-.36.38q-8.41,0-16.83,0c-.29,0-.35-.09-.35-.36q0-7,0-14c0-.32.12-.35.38-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M30.33,65.34h8.41c.29,0,.37.06.37.37q0,7,0,14c0,.27-.06.36-.35.36H21.9c-.26,0-.33-.07-.33-.33q0-7,0-14.08c0-.28.11-.31.35-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M51.24,65.34h8.33c.3,0,.4,0,.4.38q0,7,0,14c0,.32-.09.38-.4.38q-8.37,0-16.74,0c-.35,0-.4-.1-.4-.42q0-6.95,0-13.89c0-.36.11-.42.44-.42Z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(Svg22, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/22.cc72ce07.svg";
export { ForwardRef as ReactComponent };